module.exports = __webpack_public_path__ + "img/shoplogo.e7c4faf1.svg";